// extracted by mini-css-extract-plugin
export default {"tabBar":"TabBar_tabBar__NfAcq","tab":"TabBar_tab__w38QQ","tabIcon":"TabBar_tabIcon__bfNCl","tabTitle":"TabBar_tabTitle__Ks1nF","activeTab":"TabBar_activeTab__2E8TS"};